/**
 * Enum configs for all Feature Flags in our system
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Kelvin Nguyen
 */
export const FeatureNames = {
  homeTour: 'homeTour',
  boardTour: 'boardTour',
  boardFtu: 'boardFtu',
  feature: 'feature',
  destinationPage: 'destinationPage'
}

export const FlagNames = {
  [FeatureNames.homeTour]: {
    welcomeBanner: 'welcomeBanner'
  },
  [FeatureNames.boardTour]: {
    ftu: 'ftu',
    addList: 'addList',
    addPlace: 'addPlace',
    otherFeatures: 'otherFeatures'
  },
  [FeatureNames.boardFtu]: {
    firstPlaceAdded: 'firstPlaceAdded'
  },
  [FeatureNames.feature]: {
    datepicker: 'datepicker'
  },
  [FeatureNames.destinationPage]: {
    searchDestination: 'searchDestination',
    showPlaceCards: 'showPlaceCards'
  }
}

export default {
  FeatureNames,
  FlagNames
}
